import { Link } from "react-router-dom";
import type { Anime } from "@/mocks/types";

interface RankingListProps {
  items: Anime[];
}

export default function RankingList({ items }: RankingListProps) {
  return (
    <div className="bg-background-50 rounded-lg border border-background-200 overflow-hidden">
      <div className="px-4 md:px-5 py-3.5 border-b border-background-200 flex items-center justify-between">
        <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base flex items-center gap-2">
          <span className="w-5 h-5 flex items-center justify-center text-primary-600">
            <i className="ri-fire-fill text-base" />
          </span>
          热度排行榜
        </h3>
        <span className="text-[11px] text-foreground-400 font-label">近 7 日</span>
      </div>
      <ul>
        {items.map((anime, idx) => (
          <li key={anime.id} className="border-b border-background-200/70 last:border-b-0">
            <Link
              to={`/anime/detail/${anime.id}`}
              className="flex items-center gap-3 px-4 md:px-5 py-3 hover:bg-background-100 transition-colors duration-200 cursor-pointer group"
            >
              <span
                className={`w-5 shrink-0 text-center font-heading font-bold text-sm ${
                  idx < 3 ? "text-primary-600" : "text-foreground-400"
                }`}
              >
                {idx + 1}
              </span>
              <div className="w-10 h-12 shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={anime.cover}
                  alt={anime.title}
                  title={`${anime.title} 热门动漫`}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors duration-200">
                  {anime.title}
                </p>
                <p className="mt-0.5 text-[11px] text-foreground-500 truncate">
                  {anime.genres.slice(0, 2).join(" · ")} · {anime.year}
                </p>
              </div>
              <span className="shrink-0 text-[11px] text-foreground-500 font-label">
                {anime.rating.toFixed(1)}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}